<template>
  <div>
    <w-form-table :model="model">
      <template v-slot:thead>
        <tr>
          <th class="text-middle" width="5%">L.p.</th>
          <th class="center-parent text-middle" :width="switcher ? '55%' : '35%'">
            <span class="center-child">{{switcher ? "Nazwa PKD" : "Symbol PKD"}}</span>
            <button
              @click="switcher = !switcher"
              class="btn btn-xs btn-default btn-gray pull-right"
            >
              <span v-show="switcher">
                <i class="fa fa-sort-alpha-asc"></i>
              </span>
              <span v-show="!switcher">
                <i class="fa fa-sort-numeric-asc"></i>
              </span>&nbsp;Zmień metodę wprowadzania
            </button>
          </th>
          <th class="text-middle">{{switcher ? "Symbol PKD" : "Nazwa PKD"}}</th>
          <th width="5%"></th>
        </tr>
      </template>
      <tbody>
        <tr v-for="(item, index) in model.$items" :key="'przedmiot' + index">
          <w-lp-cell :index="index"></w-lp-cell>
          <w-table-cell css="input" :model="item.$item">
            <w-pkd-select
              :model="item.$item"
              :show-switcher="false"
              :show-symbols-first="switcher"
              v-on:switcher="(val)=>{switcher = val}"
            ></w-pkd-select>
          </w-table-cell>
          <w-table-cell css="input state-disabled" :model="item.$item.Text" v-show="!switcher">
            <w-preview :model="item.$item.Text"></w-preview>
          </w-table-cell>
          <w-table-cell css="input state-disabled" :model="item.$item.Value" v-show="switcher ">
            <w-preview :model="item.$item.Value"></w-preview>
          </w-table-cell>
          <w-row-buttons :model="item.$item"></w-row-buttons>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="4">
            <w-add-row :model="model">Dodaj przedmiot</w-add-row>
          </td>
        </tr>
      </tfoot>
    </w-form-table>
  </div>
</template>
<script>
import modelMixin from '../mixins/modelMixin';

export default {
  name: 'pkd-table',
  mixins: [modelMixin],
  props: {
    name: 'pkd-select'
  },
  data() {
    return {
      switcher: true
    };
  }
};
</script>
<style >
.btn-gray {
  color: #333 !important;
  background-color: #ebebeb !important;
  border-color: #adadad !important;
  box-shadow: none !important;
  -moz-box-shadow: none !important;
  -webkit-box-shadow: none !important;
}
.btn-gray:hover {
  background-color: #e0e0e0 !important;
}
.center-parent {
  position: relative;
  height: 100%;
}
.center-child {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
</style>